import { render, staticRenderFns } from "./FurnitureCategory.vue?vue&type=template&id=64f64283&"
import script from "./FurnitureCategory.vue?vue&type=script&lang=js&"
export * from "./FurnitureCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports